import React from 'react';
import styles from './styles.module.scss';
import cN from 'classnames';
import { useMediaQuery } from 'react-responsive';

import M from './subComponent/M';
import Pc from './subComponent/Pc';

interface I_SearchResultCardsProps {
    openPanelM: () => void;
    openCalendarPC: () => void;
}

const SearchResultCards = ({ openPanelM, openCalendarPC }: I_SearchResultCardsProps) => {
    const moduleName = 'resultCards';
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    // TODO 待合併
    return (
        <div className={cN(moduleName, styles[moduleName])}>
            {isMobile ? <M openPanelM={openPanelM} /> : <Pc openCalendarPC={openCalendarPC} />}
        </div>
    );
};

export default SearchResultCards;
